import { render } from "./CategoryPageLoader.vue?vue&type=template&id=5a3c013c"
import script from "./CategoryPageLoader.vue?vue&type=script&lang=js"
export * from "./CategoryPageLoader.vue?vue&type=script&lang=js"

import "./CategoryPageLoader.vue?vue&type=style&index=0&id=5a3c013c&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__